export default __webpack_public_path__ + "static/media/03.0da9fd4d.jpg";